// import 'react-app-polyfill/stable'
import 'core-js'
import React, { Suspense } from 'react'
import ReactDOM from "react-dom/client";
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from './service/store'
import './i18n'
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-number-input/style.css'
import './index.css'
import './css/index.css'
import { QueryClient, QueryClientProvider } from 'react-query';
import ErrorBoundary from './components/ErrorBoundary';



const loading = (
  <div className="pt-3 text-center">
    <div className='d-flex justify-content-center w-100 align-items-center' style={{ height: '100vh' }}>
      <div className="spinner-border text-dark"></div>

    </div>
  </div>
)
const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();
root.render(


  <Provider store={store}>
    <Suspense fallback={loading}>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </QueryClientProvider>
    </Suspense>
  </Provider>

)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
